/**
 * @file hippy状况下cookie设置兼容，封装接入层域名处理
 */
import get from 'lodash/get';
import set from 'lodash/set';
import identity from 'lodash/identity';
// import values from 'lodash/values';
// import { ACCESS_DOMAIN, EnvironmentMode } from '../../config/constants';


// const DEFAULT_DOMAIN = ACCESS_DOMAIN[EnvironmentMode.RELEASE];
const DEFAULT_URL = 'https://v.qq.com';
const isEvo = import.meta.env.EVO;

export default {
  remove(url: string, key: string): void {
    this.set(url, key, '', new Date(0));
  },

  set(url: string, key: string, value = '', expireDate?: Date): void {
    if (process.env.IS_MULTI_WEB) {
      console.warn('[util/cookie] non-native caller. URL ignored.');
      const expires = expireDate instanceof Date ? `expires=${expireDate.toUTCString()};` : '';
      document.cookie = `${key}=${value};path=/;${expires}`;
    }
  },

  setAll(url: string, pair: Record<string, string>, expireDate?: Date): void {
    Object.entries(pair).forEach(([key, value]) => {
      this.set(url, key, value, expireDate);
    });
  },

  // setCookieForAllDomain(pair: Record<string, string>, expireDate?: Date): void {
  //   values(ACCESS_DOMAIN).forEach((domain) => {
  //     this.setAll(`https://${domain}`, pair, expireDate);
  //   });
  // },

  async get(url: string = DEFAULT_URL, key: string): Promise<string> {
    try {
      const cookies = await this.toJSON(url);
      return String(get(cookies, key, ''));
    } catch (error) {
      console.error('[util/cookie]', `get '${key}' error.`, error);
      return '';
    }
  },

  async toJSON(): Promise<Record<string, unknown>> {
    try {
      let cookies = '';
      if (isEvo) {
        cookies = (global.vnContext?.external?.getLoginCookie() || global.vn?.external?.getLoginCookie() || '').replace('Cookie:', '');
      } else {
        console.warn('[util/cookie] non-native caller. URL ignored.');
        cookies = document.cookie || '';
      }
      return cookies.split(';').filter(identity)
        .reduce((obj: Record<string, unknown>, cookie = '') => {
          const [k, v] = cookie.split('=');
          set(obj, k.trim(), v);
          return obj;
        }, {});
    } catch (error) {
      console.error('[util/cookie]', 'toJSON error.', error);
      return {};
    }
  },
};
